<template>
  <v-dialog v-model="brandSearchDialog" width="800">
    <customDialog>
      <template v-slot:title>
        {{t('brandSelect')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img"
						@click="brandSearchDialog = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" align="center">
          <v-col class="ma-0 pa-0" cols="12"
						style="min-height:150px;">
						<v-item-group class="ma-0 pa-0" dense v-model="selectedBrands" dark
							hide-details :column="false" mandatory>
							<v-row class="ma-0 pa-0" align="center">
								<v-col class="ma-0 pa-0 ml-2 mr-2" cols="auto" 
									v-for="(item, index) in brandList" :key="index">
									<v-item :value="item" v-slot="{ active, toggle }">
										<v-col class="ma-0 pa-2 grey_item" cols="auto" @click="toggle"
											:class="{'selected_item':active}">
											<v-row class="ma-0 pa-0" align="center">
												<v-icon class="ma-0 pa-0 mr-1" color="#008DD0"
													v-if="active">mdi-radiobox-marked</v-icon>
												<v-icon class="ma-0 pa-0 mr-1" dark
													v-else>mdi-radiobox-blank</v-icon>
												{{item.brandName + ' (' + item.count + ')'}}
											</v-row>
										</v-col>
									</v-item>  
								</v-col>
							</v-row>       
						</v-item-group>
          </v-col>
					<v-col class="ma-0 pa-0 mt-5 mb-2" cols="12">
						<v-row class="ma-0 pa-0" align="center" justify="center">
							<v-btn width="8rem" height="auto" class="ma-0 pa-2" 
								id="grey_btn" elevation="0" @click="reset">
									{{t('reset')}}
							</v-btn>
              <v-btn width="8rem" height="auto" class="ma-0 pa-2 ml-2" 
								id="grey_btn" elevation="0" @click="brandSearchDialog = false">
									{{t('cancel')}}
							</v-btn>
							<v-btn width="8rem" height="auto" class="ma-0 pa-2 ml-2" 
								id="blue_btn" elevation="0" @click="editBrands">
									{{t('confirm')}}
							</v-btn>
						</v-row>
					</v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';
export default {
  props: {
    dialogVisible: Boolean
  },
  components: {
    customDialog
  },
  mixins: [mixin.common],
  data: () => ({
    brandSearchDialog: false,
		selectedBrands: {},
    brandList: [],
  }),
  watch: {
    dialogVisible: function(item) {
      this.brandSearchDialog = item;
			if(item == true) {
				this.brandList = [];
				let searchCondition = this.$store.getters.getSearchCondition;
				// searchCondition.selectedBrands.forEach((brand) => {
				// 	this.brandList.push(brand);
				// });
				// this.selectedBrands = this.brandList;
        this.selectedBrands = searchCondition.selectedBrands;
        this.brandList.push(this.selectedBrands);
			}
    },
    brandSearchDialog: function(item) {
      this.$emit('visible', item);
    },
  },
  created() {

  },
  methods: {
		reset() {
			this.selectedBrands = this.brandList;
		},
    editBrands() {
			this.$emit('editBrands', this.selectedBrands);
			this.brandSearchDialog = false;
		},
  }
}
</script>

<style lang="scss" scoped>
.grey_item {
	cursor: pointer;
	border: 1px solid #6A6A6A;
	background-color: #4E4E4E;
	border-radius: 4px;
	color: white;
	min-width: 1rem;
}
.selected_item {
	cursor: pointer;
	background-color: #4E4E4E;
	border-radius: 4px;
	color: white;
	min-width: 1rem;
	border: 2px solid #008DD0;
}
#grey_btn {
	border: 1px solid #6A6A6A;
}
</style>